import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="image-field"
export default class extends Controller {
  connect() {
  }

  // Called when the image field changes
  change(event) {
    const input = event.target
    if (input.files && input.files[0]) {
      const reader = new FileReader()
      reader.onload = (e) => {
        const parent = $(input).closest('[data-controller="image-field"]')
        
        // Handle both image_form_group and image_form_group_with_color structures
        let imgElement = parent.find(".image-input-wrapper img")
        if (imgElement.length === 0) {
          // For image_form_group_with_color, the img is directly in the wrapper
          imgElement = parent.find("img.img-rounded")
        }
        
        imgElement.attr('src', e.target.result)
        parent.find('.remove_btn').show();
        parent.find('input[type="checkbox"]').prop('checked', false);
      }
      reader.readAsDataURL(input.files[0])
    }
  }

  // Called when the image field is clicked
  click(event) {
    const input = event.target;
    const parent = $(input).closest('[data-controller="image-field"]');
    parent.find('input[type="file"]').click()
  }

  // Called when the remove image field is clicked
  remove(event) {
    const input = event.target;
    const parent = $(input).closest('[data-controller="image-field"]');
    const default_src = parent.find(".default-img").attr('src');
    parent.find('input[type="checkbox"]').prop('checked', true);
    
    // Handle both image_form_group and image_form_group_with_color structures
    let imgElement = parent.find(".image-input-wrapper img")
    if (imgElement.length === 0) {
      // For image_form_group_with_color, the img is directly in the wrapper
      imgElement = parent.find("img.img-rounded")
    }
    
    imgElement.attr('src', default_src);
    parent.find('.remove_btn').hide();
  }
}
